export default {
  SEARCH_CURRENCY_TYPES_REPOSITORY: Symbol.for('SEARCH_CURRENCY_TYPES_REPOSITORY'),
  CURRENCY_TYPES_STATE_MANAGER: Symbol.for('CURRENCY_TYPES_STATE_MANAGER'),
  SEARCH_CURRENCY_TYPES_QUERY: Symbol.for('SEARCH_CURRENCY_TYPES_QUERY'),
};
